import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { UserFeatureResponseModel } from "api/repositories/users/model/feature/UserFeatureResponseModel";
import { isEmpty } from "lodash";
import { GrActions, GrDeploy } from "react-icons/gr";
import {
  IoBarChartSharp,
  IoFileTray,
  IoPeopleCircleOutline,
} from "react-icons/io5";
import {
  LuCode,
  LuFile,
  LuFileArchive,
  LuFileBox,
  LuFileCode,
  LuFlag,
  LuHistory,
  LuKeyRound,
  LuPackage,
  LuPackage2,
  LuSettings,
  LuTicketCheck,
  LuTruck,
  LuUserRound,
  LuUsers,
  LuWarehouse,
  LuWebhook,
} from "react-icons/lu";
import {
  MdOutlineFeaturedPlayList,
  MdOutlineInventory2,
  MdOutlineWarehouse,
} from "react-icons/md";
import { PiFolderUserBold } from "react-icons/pi";
import {
  TbArrowsExchange,
  TbBuildingWarehouse,
  TbWallet,
} from "react-icons/tb";
import { VscTools } from "react-icons/vsc";
import { RouteEnums } from "utils/enums/RouteEnums";
import { findElement } from "utils/helpers";
import { strings } from "utils/localizeStrings";
import {
  MenuConfigModel,
  SidebarConfigModel,
} from "./model/SidebarConfigModel";

export type IConfigRepository = {
  getSidebarMenu(
    // role: string
    feature: UserFeatureResponseModel[]
  ): Promise<BaseApiResponseModel<SidebarConfigModel>>;
};

export class SidebarConfigRepository implements IConfigRepository {
  getSidebarMenu(
    // role: string,
    feature: UserFeatureResponseModel[]
  ): Promise<BaseApiResponseModel<SidebarConfigModel>> {
    return new Promise((resolve, reject) => {
      let menuConfig = [];
      let baseMenu: MenuConfigModel[] = [
        findElement("statistical-transaction", feature) ||
        findElement("report-statistical-transaction", feature)
          ? new MenuConfigModel(
              strings.Sidebar.Generals,
              "/generals",
              "StatisticalTransactionFeature",
              <IoBarChartSharp />,
              []
            )
          : undefined,
        findElement("list-transaction", feature) &&
          new MenuConfigModel(
            strings.Sidebar.History,
            "/history",
            "",
            <LuHistory />,
            [
              new MenuConfigModel(
                strings.Sidebar.TransactionHistory,
                RouteEnums.transactionHistory,
                "TransactionHistoryFeature",
                <TbArrowsExchange />
              ),
            ]
          ),
        new MenuConfigModel(
          strings.Sidebar.Goods,
          "/goods",
          "",
          <LuPackage2 />,
          [
            findElement("list-goods", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Products,
                RouteEnums.goods,
                "GoodsManagementFeature",
                <LuPackage />,
                []
              ),
            findElement("list-item", feature) &&
              new MenuConfigModel(
                strings.ItemsManagement.Label,
                RouteEnums.item,
                "ItemManagementFeature",
                <LuWarehouse />,
                []
              ),
            findElement("list-field", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Fields,
                RouteEnums.field,
                "FieldManagementFeature",
                <TbBuildingWarehouse />,
                []
              ),
            findElement("list-category", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Category,
                RouteEnums.category,
                "CategoryManagementFeature",
                <TbBuildingWarehouse />,
                []
              ),
            findElement("list-variant", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Variant,
                RouteEnums.variant,
                "VariantManagementFeature",
                <TbBuildingWarehouse />,
                []
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.WarehouseManagement,
          "/storages",
          "",
          <IoFileTray />,
          [
            findElement("list-storage", feature) &&
              new MenuConfigModel(
                strings.StoragesManagement.CardTitle,
                RouteEnums.storage,
                "StorageManagementFeature",
                <MdOutlineWarehouse />,
                []
              ),
            findElement("list-inventory", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Inventory,
                RouteEnums.inventory,
                "InventoryManagementFeature",
                <MdOutlineInventory2 />,
                []
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.Partner,
          "/partners",
          "partner",
          <PiFolderUserBold />,
          [
            findElement("list-partner", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Partners,
                RouteEnums.partner,
                "PartnerMangementFeature",
                <IoPeopleCircleOutline />,
                []
              ),
            findElement("list-wallet", feature) &&
              new MenuConfigModel(
                strings.WalletManagement.MainTitle,
                RouteEnums.wallet,
                "WalletManagementFeature",
                <TbWallet />,
                []
              ),
            findElement("list-customer-profile", feature) &&
              new MenuConfigModel(
                strings.Sidebar.CustomerProfile,
                RouteEnums.customerProfile,
                "CustomerProfileManagementFeature",
                <LuFile />,
                []
              ),
            findElement("list-partner-key", feature) &&
              new MenuConfigModel(
                strings.Sidebar.PartnerKey,
                RouteEnums.partnerKey,
                "PartnerKeyManagementFeature",
                <LuKeyRound />,
                []
              ),
            !isEmpty(
              feature?.filter(
                (item) =>
                  strings.SupplierFeatureManagement.Service.Mobifone[item?.code]
              )
            )
              ? new MenuConfigModel(
                  strings.Sidebar.SupplierFeature,
                  RouteEnums.supplierFeature,
                  "SupplierManagementFeature",
                  <LuFileCode />,
                  []
                )
              : undefined,
            findElement("list-balance-ticket", feature) &&
              new MenuConfigModel(
                strings.Sidebar.BalanceTicket,
                RouteEnums.balanceTicket,
                "BalanceTicketManagementFeature",
                <LuTicketCheck />,
                []
              ),
            findElement("list-delivery-service", feature) &&
              new MenuConfigModel(
                strings.Sidebar.DeliveryService,
                RouteEnums.deliveryService,
                "DeliveryServiceManagementFeature",
                <LuTruck />,
                []
              ),
          ]
        ),

        new MenuConfigModel(
          strings.Sidebar.User,
          "/users",
          "users",
          <LuUsers />,
          [
            findElement("list-user", feature) &&
              new MenuConfigModel(
                strings.UserManagement.Title,
                RouteEnums.user,
                "UserManagementFeature",
                <LuUserRound />
              ),
            findElement("list-role", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Role,
                RouteEnums.role,
                "RoleManagementFeature",
                <LuFlag />
              ),
            findElement("list-permission", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Permission,
                RouteEnums.permission,
                "PermissionManagementFeature",
                <GrDeploy />
              ),
            findElement("list-feature", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Feature,
                RouteEnums.feature,
                "FeatureManagementFeature",
                <MdOutlineFeaturedPlayList />
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.System,
          "/systems",
          "systems",
          <VscTools />,
          [
            findElement("list-configuration", feature) &&
              new MenuConfigModel(
                strings.Sidebar.Configuration,
                RouteEnums.configuration,
                "ConfigurationManagementFeature",
                <LuSettings />
              ),
            findElement("list-error-code", feature) &&
              new MenuConfigModel(
                strings.Sidebar.ErrorCode,
                RouteEnums.errorCode,
                "ErrorCodeManagementFeature",
                <LuCode />,
                []
              ),
            findElement("list-action-log", feature) &&
              new MenuConfigModel(
                strings.ActionLogManagement.Title,
                RouteEnums.actionLog,
                "ActionLogManagementFeature",
                <GrActions />,
                []
              ),
            findElement("list-file", feature) &&
              new MenuConfigModel(
                strings.Sidebar.File,
                RouteEnums.file,
                "FilesManagementFeature",
                <LuFileBox />
              ),
          ]
        ),
        new MenuConfigModel(
          strings.Sidebar.Loading,
          "#",
          "loading",
          <LuWebhook />,
          [
            findElement("get-transaction-warehouse", feature) &&
              new MenuConfigModel(
                strings.Sidebar.TransactionWarehouse,
                RouteEnums.transactionWarehouse,
                "TransactionWarehouseFeature",
                <LuFileArchive />,
                []
              ),
          ]
        ),
      ];
      baseMenu?.forEach((item) => {
        if (item?.componentName !== "StatisticalTransactionFeature") {
          !isEmpty(item?.subMenu?.filter((child) => child !== undefined)) &&
            menuConfig?.push(item);
        } else {
          item !== undefined && menuConfig?.push(item);
        }
      });
      resolve(
        new BaseApiResponseModel<SidebarConfigModel>(
          new SidebarConfigModel(menuConfig),
          undefined,
          undefined,
          undefined,
          undefined,
          undefined
        )
      );
      return menuConfig;
    });
  }
}

export default new SidebarConfigRepository();
